import { IsAction } from '@ic-builder/iscomp';
import { IIsComponent } from '@ic-builder/is-base';

export class SetBuilderObjectState {
  static readonly type = '[SetBuilderObjectState]';
  constructor(public payload: number) {}
}

export class LoadBuilderWidgets {
  static readonly type = '[LoadBuilderWidgets]';
  constructor(public payload: string) {}
}

export class LoadBuilderForms {
  static readonly type = '[LoadBuilderForms]';
  constructor(public payload: string) {}
}

export class DeleteBuilderForm {
  static readonly type = '[DeleteBuilderForm]';
  constructor(public payload: { id: number }) {}
}

export class DeleteBuilderWizard {
  static readonly type = '[DeleteBuilderWizard]';
  constructor(public payload: { id: number }) {}
}

export class DeleteBuilderMenu {
  static readonly type = '[DeleteBuilderMenu]';
  constructor(public payload: { id: number }) {}
}

export class NewBuilderForm {
  static readonly type = '[NewBuilderForm]';
  constructor(public payload: any) {}
}

export class NewBuilderMenu {
  static readonly type = '[NewBuilderMenu]';
  constructor(public payload: any) {}
}

export class NewBuilderWizard {
  static readonly type = '[NewBuilderWizard]';
  constructor(public payload: any) {}
}

export class NewBuilderReport {
  static readonly type = '[NewBuilderReport]';
  constructor(public payload: any) {}
}

export class SetComponentEditState {
  static readonly type = '[SetComponentEditState]';
  constructor(public payload: { id: number; state: number }) {}
}

export class LoadBuilderReports {
  static readonly type = '[LoadBuilderreports]';
  constructor(public payload: string) {}
}

export class LoadBuilderFastReports {
  static readonly type = '[LoadBuilderfastreports]';
  constructor(public payload: string) {}
}

export class LoadBuilderFastReport {
  static readonly type = '[LoadBuilderfastreport]';
  constructor(public payload: number) {}
}
export class DeleteBuilderReport {
  static readonly type = '[DeleteBuilderReport]';
  constructor(public payload: { id: number }) {}
}

export class LoadBuilderMenus {
  static readonly type = '[LoadBuildermenus]';
  constructor(public payload: string) {}
}

export class LoadBuilderThemas {
  static readonly type = '[LoadBuilderThemas]';
  constructor(public payload: string) {}
}

export class LoadBuilderPropEditor {
  static readonly type = '[LoadBuilderPropEditor]';
  constructor(public payload: string) {}
}

export class LoadBuilderDatasets {
  static readonly type = '[LoadBuilderDatasets]';
  constructor(public payload: string) {}
}

export class LoadBuilderWizards {
  static readonly type = '[LoadBuilderWizards]';
  constructor(public payload: string) {}
}

export class LoadNavigationTree {
  static readonly type = '[LoadNavigationTree]';
  constructor(public payload: string) {}
}

export class SetBuilderProperty {
  static readonly type = '[SetBuilderProperty]';
  constructor(public payload: IIsComponent) {}
}

export class SetBuilderActions {
  static readonly type = '[SetBuilderActions]';
  constructor(public payload: any) {}
}

export class EditBuilderActions {
  static readonly type = '[EditBuilderActions]';

  constructor(public payload: any) {}
}

export class DeleteBuilderActions {
  static readonly type = '[DeleteBuilderActions]';

  constructor(public payload: { compid: number; eventid: number }) {}
}

export class SetBuilderCanvas {
  static readonly type = '[SetBuilderCanvas]';
  constructor(public payload: any) {}
}

export class SetBuilderDataset {
  static readonly type = '[SetBuilderDataset]';
  constructor(
    public payload: {
      id: number;
      appname: string;
      datasetname: string;
      query: string;
    }
  ) {}
}

export class UpdateDataset {
  static readonly type = '[UpdateDataset]';
  constructor(
    public payload: { id: number; appname: string; name: string; query: string }
  ) {}
}

export class SetBuilderWizard {
  static readonly type = '[SetBuilderWizard]';
  constructor(public payload: any) {}
}

export class SelectTreeNode {
  static readonly type = '[SelectNode]';
  constructor(public payload: IsAction) {}
}

export class SaveCurrentEditTree {
  static readonly type = '[SaveCurrentEditTree]';
  // constructor(public payload:number){}
}

export class NewForm {
  static readonly type = '[NewForm]';
  constructor(public payload: number) {}
}

export class RemoveComponent {
  static readonly type = '[RemoveComponent]';
  constructor(public payload: { id: number }) {}
}

export class UpdateView {
  static readonly type = '[UpdateView]';
}

export class GetEventListners {
  static readonly type = '[NewForm]';
}

export class NewWizard {
  static readonly type = '[NewWizard]';
  //constructor(public payload:number){}
}

export class NewWizardPage {
  static readonly type = '[NewWizardPage]';
  constructor(public payload: number) {}
}

export class UpdateFormFromBackend {
  static readonly type = '[UpdateFormFromBackend]';
  constructor(public payload: { id: number, Form:any, UpdateTime:number}) {}
}

export class CopyForm {
  static readonly type = '[CopyForm]';
  constructor(public payload: number) {}
}

export class SetEventHandler {
  static readonly type = '[SetEventHandler]';
  constructor(
    public payload: { events: IIsComponent[]; formid: number; compid: number }
  ) {}
}

export class SetDeviceType {
  static readonly type = '[SetDeviceType]';
  constructor(public payload: string) {}
}

export class SetDeviceResolution {
  static readonly type = '[SetDeviceResolution]';
  constructor(public payload: string) {}
}

export class SetDeviceProperties {
  static readonly type = '[SetDeviceProperties]';
  constructor(public payload: any) {}
}

export class SetSplitterProperty {
  static readonly type = '[SetSplitterProperty]';
  constructor(public payload: boolean) {}
}

export class SetScaleValue {
  static readonly type = '[SetScaleValue]';
  constructor(public payload: number) {}
}

export class AddFieldDefs {
  static readonly type = '[AddFieldDefs]';
  constructor(public payload: { name: string; children: any[] }) {}
}

export class ClearFieldDefs {
  static readonly type = '[ClearFieldDefs]';
}

export class ClearBuilderActions {
  static readonly type = '[ClearBuilderActions]';
  //constructor(public payload:number){}
}

export class UpdateComponentName {
  static readonly type = '[UpdateComponentName]';
  constructor(
    public payload: { componentype: string; name: string; id: number }
  ) {}
}

export class LoadFormInEditor1 {
  static readonly type = '[LoadFormInEditor1]';
  constructor(public payload: IIsComponent) {}
}
